module.exports = __webpack_public_path__ + "img/33-l.114bd19a.png";